Backbone = require 'backbone'
Backbone.$ = $

class EmailFormTextInputView extends Backbone.View

  initialize: (options) ->
    @options = options || {}
    @I18nScope = 'modules.support'
    @isInputFieldEmpty = true
    @maxLength = 250
    @model = @options.model
    @isFlexibleStepThree = @options.isFlexibleStepThree
    @label = @model.label
    @value = @model.value
    @base_template = @options.template
    @isInputCompulsory = @model.required is true or @model.required is "true"
    if @options.model.additional_attributes?.maximum_number_of_characters_or_digits?.length > 0
      @maxLength = parseInt(@options.model.additional_attributes.maximum_number_of_characters_or_digits)

  render: ->
    @$el.html(toHtml(@base_template, @toHash()))

  toHash: ->
    hash =
      stepThreeType: if @isFlexibleStepThree then 'flexibleStepThree' else 'defaultStepThree'
      label: @label
      required: @isInputCompulsory
      maxLength: @maxLength
      counter: @model.counter
      isLoggedIn: window.isLoggedIn
      value: @value
    _.extend @template, hash

  getInputHtmlElement: ->
    @$el.find(@elementID)

  isInputGiven: ->
    @getInputHtmlElement()?.val()?.trim()?.length > 0

  readInput: ->
    @getInputHtmlElement()?.val()?.trim()

  isInputValid: ->
    true

  validateEmailForm: ->
    if @isInputCompulsory && ((@isInputFieldEmpty && @isInputGiven()) || !(@isInputFieldEmpty || @isInputGiven()))
      @isInputFieldEmpty = !@isInputGiven()
      @options.validateEmailForm()

  populateInput: (data)->
    if @isInputGiven()
      inputData = @readInput()
      data.description += "\n\n #{@label} : #{inputData}"

module.exports = EmailFormTextInputView
